import axios from 'axios';

export const contact = (values) =>
  axios
    .post('/api/contact', values)
    .then(response => ({ data: response.data, success: true }))
    .catch(error => ({ success: false }));



// WEBPACK FOOTER //
// ./src/modules/helpdesk/_api.js